import { useId } from "react";

import { cn } from "../cn";

/**
 * Official BrandEx mark: a blue ribbon forming "X" and "B" on a white disc
 * with a blue ring. Vector trace of the owner-supplied logo (192-unit grid).
 */
export function LogoMark({ className }: { className?: string }) {
  const id = useId();
  return (
    <svg viewBox="0 0 192 192" className={cn("h-8 w-8", className)} aria-hidden>
      <defs>
        <linearGradient id={`${id}-g`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#2f8bff" />
          <stop offset="1" stopColor="#1663e6" />
        </linearGradient>
      </defs>
      <circle cx="96" cy="96" r="92" fill="#fff" stroke="#1f6fff" strokeWidth="5" />
      <path
        d="M109 68 88 96 50 140H139l7-18-21-25 20-33-4-13H47l41 45 27 28"
        fill="none"
        stroke={`url(#${id}-g)`}
        strokeWidth="16"
        strokeLinejoin="miter"
        strokeMiterlimit="3"
      />
      {/* Darker folds where the ribbon passes underneath itself. */}
      <path d="M109 68 96.5 84.7" stroke="#0e4bc4" strokeWidth="16" strokeOpacity=".55" />
      <path d="M88 96 104.3 113" stroke="#0e4bc4" strokeWidth="16" strokeOpacity=".35" />
    </svg>
  );
}

/** Mark + "BrandEx" wordmark; "Ex" in the brand blue. */
export function Logo({ className }: { className?: string }) {
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      <LogoMark />
      <span aria-hidden className="font-display text-lg font-bold tracking-tight">
        Brand<span className="text-azure-400">Ex</span>
      </span>
      <span className="sr-only">BrandEx</span>
    </span>
  );
}
